/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn24_info_circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25zM2.75 12a9.25 9.25 0 1118.5 0 9.25 9.25 0 01-18.5 0zm10.5-1a.75.75 0 00-.75-.75h-2a.75.75 0 000 1.5h1.25V17a.75.75 0 001.5 0v-6zm0-4a.75.75 0 00-1.5 0v1a.75.75 0 001.5 0V7z" _fill="#000"/>'
  }
})
